import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS, Document, INLINES, Node } from '@contentful/rich-text-types';
import { Link, Paragraph } from '@99designs/emu';

export function contentfulRichText(richTextContent: Document) {
    // Replace rich text nodes for emu components
    const options = {
        renderNode: {
            [BLOCKS.PARAGRAPH]: (node: Node, children: React.ReactNode) => (
                <Paragraph>{children}</Paragraph>
            ),
            [INLINES.HYPERLINK]: ({ data }: Node, children: React.ReactNode) => (
                <Link href={data['uri']}>{children}</Link>
            ),
        },
    };
    return documentToReactComponents(richTextContent, options);
}
